import { helpers } from '@vuelidate/validators';

// Keep frontend email validation aligned with Zod's default email rule.
export const zodEmailRegex =
  /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/;

export const matchesZodEmail = (value: string): boolean =>
  zodEmailRegex.test(value);

export const zodEmailValidator = helpers.withParams(
  { type: 'email' },
  (value: string | null | undefined): boolean => {
    if (!value) {
      return true;
    }

    return matchesZodEmail(value);
  }
);
